import { FREE_TRIAL_FORM, SUBSCRIBE_FORM } from './forms.constants';

interface MailResponseSuccess {
  success: true;
}

interface MailResponseError {
  success: false;
  'error-codes': string[];
}

export type MailResponse = MailResponseSuccess | MailResponseError;
export type RequestStatus = 'init' | 'success' | 'error' | 'pending';

export enum FormTypeEnum {
  SUBSCRIBE,
  FREE_TRIAL,
}

type FreeTrialFormGroup = typeof FREE_TRIAL_FORM;
type SubscribeFormGroup = typeof SUBSCRIBE_FORM;

export type FormGroupType<T extends FormTypeEnum> =
  T extends FormTypeEnum.SUBSCRIBE ? SubscribeFormGroup : FreeTrialFormGroup;
